import React from 'react';

const SVG = ({ style = {}, fill = '#000', width = 100, className = '', viewBox = '0 0 48 48' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    viewBox={viewBox}
    className={`svg-icon ${className || ''}`}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h48v48H0z" />
      <path
        fill="#53A318"
        d="M39.27 12.935c.407.406.636.957.636 1.532v10.298a2.17 2.17 0 0 1-.635 1.533L24.639 40.932a2.159 2.159 0 0 1-1.533.635 2.16 2.16 0 0 1-1.533-.635L6.938 26.298a2.168 2.168 0 0 1 0-3.065L21.57 8.599a2.169 2.169 0 0 1 1.533-.636h10.3c.574 0 1.126.23 1.533.636l4.335 4.336zm-7.494 5.895a2.737 2.737 0 1 0 0-5.474 2.737 2.737 0 0 0 0 5.474z"
      />
    </g>
  </svg>
);

export default SVG;
